import { render, staticRenderFns } from "./AllowancesPlanForm.vue?vue&type=template&id=04849ab2&scoped=true&"
import script from "./AllowancesPlanForm.vue?vue&type=script&lang=js&"
export * from "./AllowancesPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04849ab2",
  null
  
)

export default component.exports